import { useMutation } from "@tanstack/react-query";

import { resendVerificationEmail } from "~/api/resendEmail";
import { toastSuccessMessage } from "~/shared/utils/toastSuccessMessage";
import { errorToast } from "~/ui/admin";

export const useEmailVerification = () => {
  const resend = useMutation({
    mutationFn: resendVerificationEmail,
    onSuccess: (data) => {
      toastSuccessMessage(data.data.message);
    },
    onError: errorToast,
  });

  const send = useMutation({
    mutationFn: resendVerificationEmail,
    onError: errorToast,
  });

  return {
    resend,
    send,
  };
};
